import { PaymentFrequencyComponent, MakeWholeCallComponent } from "@goodfill/domain-properties-components";
import { Field } from "../../../../ui-components";
import { PricedBond } from "../../PricedBond";
import { MoreAboutBox } from "./MoreAboutBox";

export const BondDetailTheWorks = ({ pricedBond, className }: { pricedBond: PricedBond; className?: string }) => {
  return (
    <MoreAboutBox title="The Works" className={className}>
      <div className="grid grid-cols-2 gap-8">
        <Field label={"Industry"} textAlign="left" labelClassName="whitespace-unset-important">
          {pricedBond.industry}
        </Field>
        <Field label={"Payment Frequency"} textAlign="left" labelClassName="whitespace-unset-important">
          <PaymentFrequencyComponent value={pricedBond.couponFrequency} />
        </Field>
        <Field label={"ISIN"} textAlign="left" labelClassName="whitespace-unset-important">
          {pricedBond.isin}
        </Field>
        <Field label={"Make Whole Call"} textAlign="left" labelClassName="whitespace-unset-important">
          <MakeWholeCallComponent value={pricedBond.makeWholeCall} />
        </Field>
        <Field label={"Payment Rank"} textAlign="left" labelClassName="whitespace-unset-important">
          {pricedBond.paymentRank}
        </Field>
      </div>
    </MoreAboutBox>
  );
};
